export default __webpack_public_path__ + "media/images/gallery/27-64f7c3e2882f8fb8e2ccccb0594eaed2.jpg";